module.exports = __webpack_public_path__ + "media/images/main-bg-380c082eb9cf2a6230cdb82c6bef48df.jpg";